const enum BrowserTypes {
  MOBILE_SAFARI = 'Mobile Safari',
  SAFARI = 'Safari',
  FIREFOX = 'Firefox',
}

export default BrowserTypes;
